import apiClient from "services/axios";

const API = {
  list: "/api/v1/blocks",
  create: "/api/v1/blocks",
  detail: "/api/v1/blocks",
  update: "/api/v1/blocks",
  delete: "/api/v1/blocks",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const add = async (body) => {
  const response = await apiClient.post(API.create, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (id, body) => {
  const response = await apiClient.patch(`${API.update}/${id}`, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
